import React, { useContext } from "react";
import { AppContext } from "../../components/AppProvider";
import { Doctor } from "../../resources/Assets";


export const DoctorMsgBox = () => {
    const {userinfo} = useContext(AppContext);

    return (
        <div className="doctor-massage-box">
            <div className="dot-photo">
                <DoctorFace pcnt={50} />
            </div>

            <p>
                ‘{userinfo.userName} 님’ 10일 동안<br />
                목표 운동의 80%를 도달하였습니다.
            </p>
        </div>
    );
};

export const DoctorFace = (props) => {
    const {userinfo} = useContext(AppContext);
    const {pcnt} = props
    return(
        <div className="dot-photo">
            {
                pcnt >= 50
                    ?   userinfo.sex == '1' 
                        ? <img src={Doctor.male.good} alt="" /> 
                        : <img src={Doctor.female.good} alt="" />
                    :   userinfo.sex == '1' 
                        ? <img src={Doctor.male.bad} alt="" /> 
                        : <img src={Doctor.female.bad} alt="" />
            }
        </div>
    );
}